import { PromoToolSlot } from '@/types/amplience';
import { CartAndLineItemGroups } from '@/types/commercetools';

const filterLineItemGroups = (
  cartAndLineItemGroups: CartAndLineItemGroups,
  productTypeIds: string[]
) => {
  return cartAndLineItemGroups.lineItemGroups.filter(
    (group) => group.productTypeId && productTypeIds.includes(String(group.productTypeId))
  );
};

export const canApplyPromo = (
  cartAndLineItemGroups: CartAndLineItemGroups | undefined | null,
  promoConfig: PromoToolSlot | null,
  activePromoCode: { code: string } | null
) => {
  if (
    !promoConfig ||
    !cartAndLineItemGroups ||
    !activePromoCode ||
    activePromoCode.code !== promoConfig.content['promo-tool'].campaignDetails.code
  ) {
    return false;
  }

  const productTypeIdsInCart = cartAndLineItemGroups.lineItemGroups.map((g) =>
    String(g.productTypeId)
  );

  const matchingCondition = promoConfig.content['promo-tool'].promoConditions.find((condition) => {
    // Important: we do not check restrictions.productTypeCategories in here as the server will resolve these to productTypeIds

    // condition cant match if product types are defined but given product type id is not included
    if (
      condition.restrictions.productTypes &&
      !condition.restrictions.productTypes.some((ptId) => productTypeIdsInCart.includes(ptId))
    ) {
      return false;
    }

    if (condition.restrictions.minOrderItems) {
      const basketItemCount = condition.restrictions.restrictByCategoryOrProductTypes
        ? filterLineItemGroups(
            cartAndLineItemGroups,
            condition.restrictions.productTypes || []
          ).reduce((sum, group) => sum + group.groupQuantity, 0)
        : cartAndLineItemGroups.cart.totalLineItemQuantity;

      if (basketItemCount < condition.restrictions.minOrderItems) {
        return false;
      }
    }

    if (condition.restrictions.minOrderValue) {
      const basketValue = condition.restrictions.restrictByCategoryOrProductTypes
        ? filterLineItemGroups(
            cartAndLineItemGroups,
            condition.restrictions.productTypes || []
          ).reduce((sum, group) => sum + group.groupTotalCentAmount, 0)
        : cartAndLineItemGroups.lineItemGroups.reduce((sum, group) => {
            return sum + group.groupTotalCentAmount;
          }, 0);

      if (basketValue / 100 < condition.restrictions.minOrderValue) {
        return false;
      }
    }

    return true;
  });

  const cartCoupons = cartAndLineItemGroups.cart?.custom?.fields?.sprdVoucherList?.split(',') || [];

  return !!matchingCondition && !cartCoupons.includes(activePromoCode.code);
};
